package team.platforma.materialextension


import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.BoxWithConstraints
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.Menu
import androidx.compose.material3.Card
import androidx.compose.material3.DrawerValue
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.ModalDrawerSheet
import androidx.compose.material3.ModalNavigationDrawer
import androidx.compose.material3.NavigationDrawerItem
import androidx.compose.material3.Scaffold
import androidx.compose.material3.Slider
import androidx.compose.material3.SliderDefaults
import androidx.compose.material3.TabRowDefaults
import androidx.compose.material3.TabRowDefaults.tabIndicatorOffset
import androidx.compose.material3.Text
import androidx.compose.material3.darkColorScheme
import androidx.compose.material3.lightColorScheme
import androidx.compose.material3.rememberDrawerState
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableFloatStateOf
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.blur
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.graphicsLayer
import androidx.compose.ui.input.key.Key
import androidx.compose.ui.layout.onGloballyPositioned
import androidx.compose.ui.unit.dp
import androidx.compose.ui.window.Dialog
import androidx.compose.ui.zIndex
import androidx.navigation.compose.NavHost
import androidx.navigation.compose.composable
import androidx.navigation.compose.currentBackStackEntryAsState
import androidx.navigation.compose.rememberNavController
import kotlinx.coroutines.launch
import materialextension.composeapp.generated.resources.Res
import materialextension.composeapp.generated.resources.settings
import org.jetbrains.compose.resources.painterResource
import org.jetbrains.compose.ui.tooling.preview.Preview
import system_component_style.SystemStyle
import team.platforma.materialextension.screen.CalendarView
import team.platforma.materialextension.screen.ListScreenDebug
import team.platforma.materialextension.screen.OneTap
import team.platforma.materialextension.screen.PersonalData
import team.platforma.materialextension.screen.PersonalDataPhoneTest
import team.platforma.materialextension.screen.SignSample
import team.platforma.materialextension.screen.SmsCodeSample
import team.platforma.materialextension.screen.TrashDebug
import team.platforma.materialextension.screen.WebViewTest
import team.platforma.materialextension.theme.CalendarTheme
import team.platforma.materialextension.theme.DropDownFieldTheme
import team.platforma.materialextension.theme.ExtraInputChipTheme
import team.platforma.multiplatform_material_extension.toolbar.Toolbar
import team.platforma.materialextension.theme.ToolbarTheme
import team.platforma.materialextension.theme.TooltipTheme
import team.platforma.multiplatform_material_extension.bottom_sheet.utils.isVisible
import team.platforma.multiplatform_material_extension.bottom_sheet.utils.rememberBottomSheetState
import team.platforma.multiplatform_material_extension.tab_row.style.AdaptiveTabRowStyle
import team.platforma.multiplatform_material_extension.tab_row.style.Tab
import team.platforma.multiplatform_material_extension.tab_row.style.TabRow
import team.platforma.multiplatform_material_extension.text_input.style.TextInput
import team.platforma.multiplatform_material_extension.ui.dialog.utils.isVisible
import team.platforma.multiplatform_material_extension.ui.dialog.utils.rememberCommonDialogViewState
import team.platforma.multiplatform_material_extension.ui.theme.ThemeSwitcher
import team.platforma.multiplatform_material_extension.ui.theme.isDark
import team.platforma.multiplatform_material_extension.ui.theme.rememberTheme
import team.platforma.multiplatform_material_extension.util.keyGrabber
import team.platforma.multiplatform_material_extension.util.rememberKeyGrabber
import kotlin.math.abs
import kotlin.math.roundToInt

@OptIn(ExperimentalMaterial3Api::class)
@Composable
@Preview
fun App() {

    val theme = rememberTheme(autoSwitch = true)
    val dialogState = rememberCommonDialogViewState()
    val sheetState = rememberBottomSheetState()

    val keyGrabber = rememberKeyGrabber()

    ExtraInputChipTheme().light()

    TextInput.define(
        style = TextInput.Style.Outline
    )


    AdaptiveTabRowStyle.define(
        tab = Tab(
            indicator = { tabPositions, selectedTabIndex, list ->
                BoxWithConstraints(
                    modifier = Modifier.fillMaxHeight()
                ) {
                    TabRowDefaults.SecondaryIndicator(
                        modifier = Modifier.fillMaxHeight()
                            .tabIndicatorOffset(tabPositions[selectedTabIndex])
                            .zIndex(0f).then(
                                if (list[selectedTabIndex] == list.first()) {
                                    Modifier.background(
                                        Color.Red,
                                        RoundedCornerShape(
                                            topStart = 6.dp,
                                            bottomStart = 6.dp
                                        )
                                    )
                                } else if (list[selectedTabIndex] == list.last()) {
                                    Modifier.background(
                                        Color.Red,
                                        RoundedCornerShape(topEnd = 6.dp, bottomEnd = 6.dp)
                                    )
                                } else {
                                    Modifier.background(
                                        Color.Red
                                    )
                                }
                            ),
                        color = Color.Transparent,
                        height = maxHeight
                    )
                }
            },
            defaultTabModifier = Modifier.border(
                width = 1.dp,
                color = Color.Red
            ),
//            firstItemModifier = Modifier.border(
//                width = 1.dp,
//                color = Color.Red,
//                RoundedCornerShape(
//                    topStart = 6.dp,
//                    bottomStart = 6.dp
//                )
//            ),
//            lastItemModifier = Modifier.border(
//                width = 1.dp,
//                color = Color.Red,
//                RoundedCornerShape(topEnd = 6.dp, bottomEnd = 6.dp)
//            )
        ),
        tabRow = TabRow(
            divider = {}
        )
    )

    if (theme.isDark()) {
        SystemStyle().darkStatusBarIcons(false)
        CalendarTheme().dark()
        ToolbarTheme().dark()
        TooltipTheme().dark()
        DropDownFieldTheme().light()
    } else {
        SystemStyle().darkStatusBarIcons(true)
        CalendarTheme().light()
        ToolbarTheme().light()
        TooltipTheme().light()
        DropDownFieldTheme().light()
    }

    MaterialTheme(
        colorScheme = if (theme.isDark()) darkColorScheme() else lightColorScheme()
    ) {
        val navController = rememberNavController()

        val backStackEntry by navController.currentBackStackEntryAsState()
        val currentScreen = backStackEntry?.destination

        val drawerState = rememberDrawerState(initialValue = DrawerValue.Closed)
        val scope = rememberCoroutineScope()

        var drawerWidth by remember { mutableStateOf(0f) }

        val screens = listOf(
            SignSample,
            SmsCodeSample,
            PersonalData,
            CalendarView,
            TrashDebug,
            PersonalDataPhoneTest,
            WebViewTest,
            ListScreenDebug,
            OneTap
        )

        var animationSettingsDialog by remember { mutableStateOf(false) }

        var translationXSetting by remember { mutableFloatStateOf(188f) }
        var rotationXSetting by remember { mutableFloatStateOf(9f) }

        var scaleXSetting by remember { mutableFloatStateOf(0.38f) }
        var scaleYSetting by remember { mutableFloatStateOf(0.23f) }

        ModalNavigationDrawer(
            modifier = Modifier.keyGrabber(keyGrabber, listOf(Key.Enter))
                .then(
                    if (dialogState.isVisible() || sheetState.isVisible()) Modifier.blur(5.dp) else Modifier
                ),
            drawerState = drawerState,
            gesturesEnabled = !drawerState.isClosed,
            drawerContent = {
                ModalDrawerSheet(
                    modifier = Modifier.onGloballyPositioned { coordinates ->
                        drawerWidth = coordinates.size.width.toFloat()
                    }
                ) {
                    Text("Drawer title", modifier = Modifier.padding(16.dp))
                    HorizontalDivider()
                    screens.forEach { screen ->
                        NavigationDrawerItem(
                            label = { Text(text = screen.title) },
                            selected = currentScreen?.route == screen.route,
                            onClick = {

                                scope.launch {
                                    drawerState.apply {
                                        if (isClosed) open() else close()
                                    }
                                }

                                navController.navigate(screen.route)
                            }
                        )
                    }

                    // ...other drawer items
                }
            }
        ) {

            val offset = ((drawerWidth - abs(drawerState.currentOffset)) / drawerWidth)

//            Log().print("offset", "offset = $offset , drawerWidth = $drawerWidth")


            Scaffold(
                modifier = Modifier.graphicsLayer {
                    // Apply scaling and translation based on drawer progress
                    scaleX = 1f - scaleXSetting * offset
                    scaleY = 1f - scaleYSetting * offset
                    translationX =
                        translationXSetting * offset // Adjust translation value as needed
                    rotationY = rotationXSetting.unaryMinus() * offset
                },
                topBar = {
                    Toolbar(
                        title = {
                            Text(
                                text = "Material Extension Lib"
                            )
                        },
//                        colors = TopAppBarDefaults.topAppBarColors(
//                            containerColor = MaterialTheme.colorScheme.primaryContainer,
//                            titleContentColor = MaterialTheme.colorScheme.primary,
//                        ),
                        navigationIcon = {
                            IconButton(onClick = {
                                scope.launch {
                                    drawerState.apply {
                                        if (isClosed) open() else close()
                                    }
                                }
                            }) {
                                Icon(
                                    imageVector = Icons.Filled.Menu,
                                    contentDescription = "Menu"
                                )
                            }
                        },
                        actions = {

                            ThemeSwitcher()

                            IconButton(onClick = {
                                animationSettingsDialog = true
                            }) {
                                Icon(
                                    painterResource(Res.drawable.settings),
                                    contentDescription = "Settings"
                                )
                            }
                        }
                    )
                }
            ) { paddingValues ->
                Box(
                    modifier = Modifier.padding(paddingValues),
                    contentAlignment = Alignment.Center
                ) {
                    NavHost(
                        navController = navController,
                        startDestination = SignSample.route
                    ) {
                        screens.forEach { screen ->
                            composable(route = screen.route) {
                                screen.screen.invoke()
                            }
                        }
                    }

                    if (animationSettingsDialog) {
                        Dialog(
                            onDismissRequest = { animationSettingsDialog = false }
                        ) {
                            Card(
                                modifier = Modifier.fillMaxWidth(),
                                shape = RoundedCornerShape(8.dp)

                            ) {
                                Column(
                                    modifier = Modifier.padding(8.dp)
                                ) {

                                    Text(text = "Сдвиг $translationXSetting бобров")

                                    Slider(
                                        value = translationXSetting,
                                        onValueChange = {
                                            translationXSetting = it.roundToInt().toFloat()
                                        },
                                        colors = SliderDefaults.colors(
                                            thumbColor = MaterialTheme.colorScheme.secondary,
                                            activeTrackColor = MaterialTheme.colorScheme.secondary,
                                            inactiveTrackColor = MaterialTheme.colorScheme.secondaryContainer,
                                        ),
                                        steps = 50,
                                        valueRange = 0f..200f
                                    )

                                    Text(text = "Поворот $rotationXSetting бобров")

                                    Slider(
                                        value = rotationXSetting,
                                        onValueChange = {
                                            rotationXSetting = it.roundToInt().toFloat()
                                        },
                                        colors = SliderDefaults.colors(
                                            thumbColor = MaterialTheme.colorScheme.secondary,
                                            activeTrackColor = MaterialTheme.colorScheme.secondary,
                                            inactiveTrackColor = MaterialTheme.colorScheme.secondaryContainer,
                                        ),
                                        steps = 10,
                                        valueRange = 0f..10f
                                    )

                                    Text(text = "Уменьшение по X $scaleXSetting бобров")

                                    Slider(
                                        value = scaleXSetting,
                                        onValueChange = {
                                            scaleXSetting = (it * 100).roundToInt() / 100f
                                        },
                                        colors = SliderDefaults.colors(
                                            thumbColor = MaterialTheme.colorScheme.secondary,
                                            activeTrackColor = MaterialTheme.colorScheme.secondary,
                                            inactiveTrackColor = MaterialTheme.colorScheme.secondaryContainer,
                                        ),
                                        steps = 50,
                                        valueRange = 0f..0.5f
                                    )

                                    Text(text = "Уменьшение по Y $scaleYSetting бобров")

                                    Slider(
                                        value = scaleYSetting,
                                        onValueChange = {
                                            scaleYSetting = (it * 100).roundToInt() / 100f
                                        },
                                        colors = SliderDefaults.colors(
                                            thumbColor = MaterialTheme.colorScheme.secondary,
                                            activeTrackColor = MaterialTheme.colorScheme.secondary,
                                            inactiveTrackColor = MaterialTheme.colorScheme.secondaryContainer,
                                        ),
                                        steps = 50,
                                        valueRange = 0f..0.5f
                                    )
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}
